import { render, staticRenderFns } from "./TwitterAnalyticsPublic.vue?vue&type=template&id=bd416638&scoped=true"
import script from "./TwitterAnalyticsPublic.vue?vue&type=script&lang=ts"
export * from "./TwitterAnalyticsPublic.vue?vue&type=script&lang=ts"
import style0 from "./TwitterAnalyticsPublic.vue?vue&type=style&index=0&id=bd416638&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd416638",
  null
  
)

export default component.exports